import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { createSlug, stringify } from '../../util/urlHelpers';
import { NamedLink } from '../../components';
import sunset from '../../assets/icons/sunset-palm.webp';
import landscape from '../../assets/icons/Landschaft.webp';

import css from './TransactionPanel.css';
import { LandscapeRounded } from '@material-ui/icons';

export const HEADING_ENQUIRED = 'enquired';
export const HEADING_PAYMENT_PENDING = 'pending-payment';
export const HEADING_PAYMENT_EXPIRED = 'payment-expired';
export const HEADING_REQUESTED = 'requested';
export const HEADING_ACCEPTED = 'accepted';
export const HEADING_DECLINED = 'declined';
export const HEADING_CANCELED = 'canceled';
export const HEADING_DELIVERED = 'deliveded';
export const HEADING_CONFIRMED = 'confirmed';

const createListingLink = (listingId, label, listingDeleted, searchParams = {}, className = '') => {
  if (!listingDeleted) {
    const params = { id: listingId, slug: createSlug(label) };
    const to = { search: stringify(searchParams) };
    return (
      <NamedLink className={className} name="ListingPage" params={params} to={to}>
        {label}
      </NamedLink>
    );
  } else {
    return <FormattedMessage id="TransactionPanel.deletedListingOrderTitle" />;
  }
};

const ListingDeletedInfoMaybe = props => {
  return props.listingDeleted ? (
    <p className={css.transactionInfoMessage}>
      <FormattedMessage id="TransactionPanel.messageDeletedListing" />
    </p>
  ) : null;
};

const HeadingCustomer = props => {
  const { className, id, values, listingDeleted } = props;
  return (
    <React.Fragment>
      <h1 className={className}>
        <span className={css.mainTitle}>
          <FormattedMessage id={id} values={values} />
        </span>
      </h1>
      <ListingDeletedInfoMaybe listingDeleted={listingDeleted} />
    </React.Fragment>
  );
};

const HeadingCustomerOnly = props => {
  const { className, id, listingDeleted } = props;
  return (
    <React.Fragment>
      <h1 className={className}>
      <span className={css.mainTitle}>
          <FormattedMessage id={id} />
        </span>
      </h1>
      <ListingDeletedInfoMaybe listingDeleted={listingDeleted} />
    </React.Fragment>
  );
};

const HeadingCustomerWithSubtitle = props => {
  const { className, id, values, subtitleId, subtitleValues, children, listingDeleted } = props;
  return (
    <React.Fragment>
      <h1 className={className}>
        <span className={css.mainTitle}>
          <FormattedMessage id={id} values={values} />
        </span>
        <br/>
        <FormattedMessage id={subtitleId} values={subtitleValues} />
      </h1>
      {children}
      <ListingDeletedInfoMaybe listingDeleted={listingDeleted} />
      <br/>
    </React.Fragment>
  );
};

const HeadingCustomerWithSubtitle2 = props => {
  const { className, id, values, subtitleId, subtitleValues, children, listingDeleted } = props;
  return (
    <React.Fragment>
      <h1 className={className}>
        <span className={css.mainTitle}>
          <FormattedMessage id={id} values={values} />
        </span>
      </h1>
      {children}
      <ListingDeletedInfoMaybe listingDeleted={listingDeleted} />
    </React.Fragment>
  );
};

const CustomerBannedInfoMaybe = props => {
  return props.isCustomerBanned ? (
    <p className={css.transactionInfoMessage}>
      <FormattedMessage id="TransactionPanel.customerBannedStatus" />
    </p>
  ) : null;
};

const HeadingProvider = props => {
  const { className, id, values, isCustomerBanned, children } = props;
  return (
    <React.Fragment>
      <h1 className={className}>
        <span className={css.mainTitle}>
          <FormattedMessage id={id} values={values} />
        </span>
      </h1>
      {children}
      <CustomerBannedInfoMaybe isCustomerBanned={isCustomerBanned} />
    </React.Fragment>
  );
};

const firstname=(fullname)=>{ return (
  fullname.props.user.attributes.profile.displayName.split(' ')[0]
)};

// Functional component as a helper to choose and show Order or Sale heading info:
// title, subtitle, and message
const PanelHeading = props => {
  const {
    className,
    rootClassName,
    panelHeadingState,
    customerName,
    providerName,
    listingId,
    listingTitle,
    listingDeleted,
    isCustomerBanned,
  } = props;

  const isCustomer = props.transactionRole === 'customer';

  const defaultRootClassName = isCustomer ? css.headingOrder : css.headingSale;
  const titleClasses = classNames(rootClassName || defaultRootClassName, className);
  const listingLink = createListingLink(listingId, listingTitle, listingDeleted);
  
  switch (panelHeadingState) {
    case HEADING_ENQUIRED:
      return isCustomer ? (
        <HeadingCustomerWithSubtitle2
          className={titleClasses}
          id="TransactionPanel.orderEnquiredTitle"
          values={{ listingLink }}
          listingDeleted={listingDeleted}
        >
          {!listingDeleted ? (<div>
          <h3 className={css.feedHeading}>
            <FormattedMessage
              id="TransactionPanel.activityEnqCustomer"

              values={{ providerName: firstname(providerName), listingLink }}
              //values={{ providerName, listingLink }}

            />
          </h3>
          <h3 className={css.feedHeading}>
            <FormattedMessage
              id="TransactionPanel.activityEnqCustomer2"

              values={{ providerName: firstname(providerName), listingLink }}
              //values={{ providerName, listingLink }}

            />
          </h3>
          <h3 className={css.feedHeading}>
            <FormattedMessage
              id="TransactionPanel.activityEnqCustomer3"

              values={{ providerName: firstname(providerName), listingLink }}
              //values={{ providerName, listingLink }}

            />
          </h3>
          </div>
        ) : null}
      </HeadingCustomerWithSubtitle2>
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.saleEnquiredTitle"
          values={{ customerName, listingLink,providerName }}
          isCustomerBanned={isCustomerBanned}
        >
          {!isCustomerBanned ? (
            <div>
            <h3 className={css.feedHeading}>
              <FormattedMessage id="TransactionPanel.activityEnqProvider" values={{ customerName }} />
            </h3>
            <p className={css.feedHeading}>
              <FormattedMessage id="TransactionPanel.activityEnqProvider2" values={{ customerName }} />
            </p>
            </div>
          ) : null}
        </HeadingProvider>
      );
    case HEADING_PAYMENT_PENDING:
      return isCustomer ? (
        <HeadingCustomer
          className={titleClasses}
          id="TransactionPanel.orderPaymentPendingTitle"
          values={{ listingLink }}
          listingDeleted={listingDeleted}
        />
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.salePaymentPendingTitle"
          values={{ customerName, listingLink }}
          isCustomerBanned={isCustomerBanned}
        >
          <p className={css.transactionInfoMessage}>
            <FormattedMessage
              id="TransactionPanel.salePaymentPendingInfo"
              values={{ customerName }}
            />
          </p>
        </HeadingProvider>
      );
    case HEADING_DELIVERED:
      return isCustomer ? (
        <HeadingCustomer
          className={titleClasses}
          id="TransactionPanel.orderCompleted"
          values={{ listingLink }}
          listingDeleted={listingDeleted}
        />
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.saleCompleted"
          values={{ customerName, listingLink }}
          isCustomerBanned={isCustomerBanned}
        />
      );
    case HEADING_PAYMENT_EXPIRED:
      return isCustomer ? (
        <HeadingCustomer
          className={titleClasses}
          id="TransactionPanel.orderPaymentExpiredTitle"
          values={{ listingLink }}
          listingDeleted={listingDeleted}
        />
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.salePaymentExpiredTitle"
          values={{ customerName, listingLink }}
          isCustomerBanned={isCustomerBanned}
        />
      );
    case HEADING_REQUESTED:
      return isCustomer ? (
        <HeadingCustomerWithSubtitle
          className={titleClasses}
          id="TransactionPanel.orderPreauthorizedTitle"

          values={{ customerName: firstname(customerName) }}

          subtitleId="TransactionPanel.orderPreauthorizedSubtitle"
          subtitleValues={{ listingLink }}
        >

          {!listingDeleted ? (<div>
            <h3 className={css.feedHeading}>
              <FormattedMessage
                id="TransactionPanel.orderPreauthorizedInfo"

                values={{ providerName: firstname(providerName), listingLink }}
                //values={{ providerName, listingLink }}

              />
            </h3>
            <h3 className={css.feedHeading}>
              <FormattedMessage
                id="TransactionPanel.orderPreauthorizedInfo2"
                values={{ providerName }}
              />
            </h3>
            </div>
          ) : null}
        </HeadingCustomerWithSubtitle>
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.saleRequestedTitle"
          values={{ customerName, listingLink }}
        >
          {!isCustomerBanned ? (
            <div>
            <h3 className={css.feedHeading}>
              <FormattedMessage id="TransactionPanel.saleRequestedInfo3" values={{ customerName }} />
            </h3>
            {/* <p className={titleClasses}>
              <FormattedMessage id="TransactionPanel.saleRequestedInfo2" values={{ customerName }} />
            </p> */}
            </div>
          ) : null}
        </HeadingProvider>
      );
    case HEADING_ACCEPTED:
      return isCustomer ? (
        // <HeadingCustomerOnly
        //   className={titleClasses}
        //   id="TransactionPanel.orderAcceptedSubtitle"
        // />
        <HeadingCustomerWithSubtitle2
        className={titleClasses}
        id="TransactionPanel.orderAcceptedSubtitle"

        values={{ customerName: firstname(customerName) }}
      >

        {!listingDeleted ? (<div>
          <h3 className={css.feedHeading}>
            <FormattedMessage
              id="TransactionPanel.activityConfirmation"

              values={{ providerName: firstname(providerName), listingLink }}
              //values={{ providerName, listingLink }}

            />
          </h3>
          <div className={css.iconWrapper}>
              <img src={landscape} width="350px" alt="landscape"></img>
          </div>
          </div>
        ) : null}
      </HeadingCustomerWithSubtitle2>
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.saleAcceptedTitle"
          values={{ customerName, listingLink }}
        >
          {!isCustomerBanned ? (
            <div>
            <h3 className={css.feedHeading}>
              <FormattedMessage id="TransactionPanel.saleAcceptedInfo" values={{ customerName }} />
            </h3>
            {/* <p className={titleClasses}>
              <FormattedMessage id="TransactionPanel.saleRequestedInfo2" values={{ customerName }} />
            </p> */}
            </div>
          ) : null}
          </HeadingProvider>
      );
    case HEADING_DECLINED:
      return isCustomer ? (
        <HeadingCustomer
          className={titleClasses}
          id="TransactionPanel.orderDeclinedTitle"
          values={{ customerName, listingLink }}
        />
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.saleDeclinedTitle"
          values={{ customerName, listingLink }}
          isCustomerBanned={isCustomerBanned}
        />
      );
    case HEADING_CANCELED:
      return isCustomer ? (
        <HeadingCustomer
          className={titleClasses}
          id="TransactionPanel.orderCancelledTitle"
          values={{ customerName, listingLink }}
        />
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.saleCancelledTitle"
          values={{ customerName, listingLink }}
        />
      );
    case HEADING_CONFIRMED:
      return isCustomer ? (
        <HeadingCustomerWithSubtitle2
          className={titleClasses}
          id="TransactionPanel.orderDeliveredTitle"

          values={{ customerName: firstname(customerName) }}
        >

          {!listingDeleted ? (<div>
            <h3 className={css.feedHeading}>
              <FormattedMessage
                id="TransactionPanel.orderDeliveredTitle2"

                values={{ providerName: firstname(providerName), listingLink }}
                //values={{ providerName, listingLink }}

              />
            </h3>
            <div className={css.iconWrapper}>
                <img src={sunset} width="350px" alt="sunset"></img>
            </div>
            </div>
          ) : null}
        </HeadingCustomerWithSubtitle2>
      ) : (
        <HeadingProvider
          className={titleClasses}
          id="TransactionPanel.saleDeliveredTitle"
          values={{ customerName, listingLink }}
          isCustomerBanned={isCustomerBanned}
        >
          {!isCustomerBanned ? (
            <div>
            <h3 className={css.feedHeading}>
              <FormattedMessage id="TransactionPanel.saleDeliveredInfo" values={{ customerName }} />
            </h3>
            </div>
          ) : null}
          </HeadingProvider>
      );
    default:
      console.warn('Unknown state given to panel heading.');
      return null;
  }
};

export default PanelHeading;
